import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { formatDate } from "../../../constants/helper";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Autocomplete,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const UbahPesertaKelompok = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const { id, idPesertaKelompok } = useParams();
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [namaPeserta, setNamaPeserta] = useState("");
  const [jenisJaminan, setJenisJaminan] = useState("");
  const [nomorJaminan, setNomorJaminan] = useState("");
  const [nilaiJaminan, setNilaiJaminan] = useState("");
  const [keterangan, setKeterangan] = useState("");

  const [openPeserta, setOpenPeserta] = useState(false);
  const [searchTermPeserta, setSearchTermPeserta] = useState("");
  const [error, setError] = useState(false);
  const [pesertasData, setPesertasData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClickOpenPeserta = () => {
    setOpenPeserta(true);
  };

  const handleClosePeserta = () => {
    setOpenPeserta(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const tempPostsPeserta = pesertasData.filter((val) => {
    if (searchTermPeserta === "") {
      return val;
    } else if (
      val.namaPeserta.toUpperCase().includes(searchTermPeserta.toUpperCase()) ||
      val.namaPeserta.toUpperCase().includes(searchTermPeserta.toUpperCase())
    ) {
      return val;
    }
  });

  let pesertaOptions = pesertasData.map((peserta) => ({
    label: `${peserta.namaPeserta}`,
  }));
  let jenisJaminanOptions = [
    {
      label: "SERTIFIKAT",
    },
    {
      label: "BPKB",
    },
  ];

  useEffect(() => {
    getPesertaKelompokById();
    getPesertasData();
  }, []);

  const getPesertaKelompokById = async () => {
    setLoading(true);
    const pickedPesertaKelompok = await postRequest(
      `/pesertaKelompoks/${idPesertaKelompok}`,
      {},
      navigate,
      dispatch
    );
    setNamaPeserta(pickedPesertaKelompok.data.peserta.namaPeserta);
    setJenisJaminan(pickedPesertaKelompok.data.jenisJaminan);
    setNomorJaminan(pickedPesertaKelompok.data.nomorJaminan);
    setNilaiJaminan(pickedPesertaKelompok.data.nilaiJaminan);
    setKeterangan(pickedPesertaKelompok.data.keterangan);
    setLoading(false);
  };

  const getPesertasData = async () => {
    setLoading(true);
    const allPesertas = await postRequest(`/pesertas`, {}, navigate, dispatch);
    setPesertasData(allPesertas.data);
    setLoading(false);
  };

  const updatePesertaKelompok = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      namaPeserta.length !== 0 &&
      jenisJaminan.length !== 0
    ) {
      setLoading(true);
      try {
        setLoading(true);
        await postRequest(
          `/updatePesertaKelompok/${idPesertaKelompok}`,
          {
            kelompokId: id,
            namaPeserta,
            jenisJaminan,
            nomorJaminan,
            nilaiJaminan,
            keterangan,
          },
          navigate,
          dispatch
        );
        setLoading(false);
        navigate(`/daftarKelompok/kelompok/${id}`);
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Arisan</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Detail Peserta Kelompok</h5>
      <hr />
      <Card>
        <Card.Header>Detail Peserta Kelompok</Card.Header>
        <Card.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={updatePesertaKelompok}
          >
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nama Peserta <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      freeSolo
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={pesertaOptions}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          sx={{
                            "& .MuiInputBase-input": {
                              textTransform: "uppercase",
                            },
                          }}
                          {...params}
                        />
                      )}
                      value={namaPeserta}
                      onInputChange={(e, value) => {
                        setNamaPeserta(value);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Jenis Jaminan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={jenisJaminanOptions}
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                      value={jenisJaminan}
                      onChange={(e, value) => {
                        if (value) {
                          setJenisJaminan(value.label);
                        } else {
                          setJenisJaminan("");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nomor Jaminan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={nomorJaminan}
                      onChange={(e) => {
                        setNomorJaminan(e.target.value);
                      }}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nilai Jaminan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <NumericFormat
                      required
                      value={nilaiJaminan}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        setNilaiJaminan(
                          values.formattedValue
                            .split(".")
                            .join("")
                            .replace(/,/g, "")
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={keterangan}
                      onChange={(e) => {
                        setKeterangan(e.target.value);
                      }}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() =>
                  navigate(
                    `/daftarKelompok/kelompok/${id}/${idPesertaKelompok}`
                  )
                }
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahPesertaKelompok;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};
